export const defineGoBack = () => !window.history?.state || window.history?.state?.idx === 0;
